import React, { Component } from 'react'
import  VaultResAddTokenSample from '../samples/VaultResAddTokenSample'
import { makeVaultResAddToken } from '../../../actions/vaultAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULT } from '../../../actions/types'

import { connect } from 'react-redux'
const OBJECT = [  "resAddToken", "resAddToken", "resAddToken"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    SetCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
}

export class VaultAddToken extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
    }

    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResAddToken.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResAddToken Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }

    //TODO fix this
    componentDidUpdate() {
        const { resaddtokenSuccess,ResAddTokenResponse,loading } = this.props; 
        if(ResAddTokenResponse!=="No request has been made."  && this.state.justClicked){
            if(resaddtokenSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }

    //TODO fix this
    async onMakeAddTokenPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULT, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const addTokenRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResAddToken(addTokenRequest);
        this.setState({justClicked:true});
    }
    
    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResAddToken</h3>
                < VaultResAddTokenSample/>
                <div className="requestButton" onClick={() => this.onMakeAddTokenPress()}>
                    ResAddToken Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props; 
        return (
            <div className="stepPageContainer">
            <h3 className="stepPageTitle">Vault Add Token – ResAddToken</h3>
            <div className='thingsToConsider'>
                <h3>Things to Consider:</h3> 
                <ul>
                    <li>If you intend to store the token for use in future transactions (i.e., Credential on File
                        transactions), <b>first</b> you must send either a Vault financial transaction (Purchase
                        with Vault or Pre-Authorization with Vault) or a Card Verification with Vault in order to
                        get the Issuer ID
                    </li>
                    <li>
                        The Vault Add Token request uses the Issuer ID to indicate that it is referencing stored credentials
                    </li>
                </ul>
            </div>

            <p><b>Vault Add Token transaction object definition</b></p>  
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResAddToken resAddToken = new ResAddToken(data_key, crypt_type);
                            </code>
                        case 1:
                            return <code>ResAddToken resAddToken = new ResAddToken(data_key, crypt_type);
                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_add_token', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Is Corporate Card transaction</b></p> 
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.setTransaction(resAddToken);</code>
                        case 1:
                            return <code>mpgReq.setTransaction(resAddToken);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Add Token transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>data key<br /></td>
                    <td>String<br/>25-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKey[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>electronic commerce indicator<br /></td>
                    <td>String<br/>1-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCryptType[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>
                        Credential on File Info<br/>
                        cof<br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This is a nested object
                                within the transaction, and
                                required when storing or
                                using the customer's stored
                                credentials. For information
                                about fields in the Credential
                                on FIle Info object, see Credential
                                on File Info Object
                                and Variables. 
                            </p>
                    </td>

                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCotInfo[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>


            <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Add Token transaction request fields – Optional</h3>
        <h3 className="stepPageTitle" style={{ marginLeft:"25vw",fontSize:"1vw"}}>Table 1: Vault Add Token transaction optional values</h3>
        <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/> 
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                    </td>
                        <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>AVS Information</td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAvsCheck[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>email address<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEmail[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>phone number<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2  ? OBJECT[progLangId] : ''}{METHODS.SetPhone[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>note</td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetNote[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>data key format</td>
                    <td>String<br/>2-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKeyFormat[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>
            <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Credential on File Info object request fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>issuer ID <br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This variable is
                                required for all merchant-initiated
                                transactions following
                                the first one; upon sending
                                the first transaction, the
                                issuer ID value is received in
                                the transaction response and
                                then used in subsequent
                                transaction requests.
                            </p>
                    </td>
                    <td>String<br/>
                        15-character alphanumeric<br/>
                        variable length 
                    </td>
                    <td><code>cof.SetIssuerId("VALUE_FOR_ISSUER_ID");</code><br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
                    </td>
                </tr>
                </tbody>
            </table>
            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>

          </div>
        )
    }
    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}


const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { resaddtokenSuccess,ResAddTokenResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,resaddtokenSuccess,ResAddTokenResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResAddToken})(VaultAddToken) 



